import { Chip } from "@mui/material"

import { styled } from "@cirrus/ui-kit"

export const Tag: typeof Chip = styled(Chip)({
  "& .MuiChip-deleteIcon": {
    fontSize: "16px !important",
    margin: "0 !important",
  },
  "& .MuiChip-label": {
    fontWeight: "400",
    lineHeight: "18px",
    padding: "0 6px",
  },
  "&:hover": {
    "& .MuiSvgIcon-root": {
      "&:hover": {
        opacity: 1,
      },
      opacity: 0.9,
    },
  },
  backgroundColor: "unset",
  height: "24px !important",
  maxWidth: "260px",
  padding: "3px 4px !important",
})
